import React from 'react';

import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { DTRRule } from '../types';

import CustomDrawer from 'components/shared/Drawer/Drawer';

import { DTRRuleDataLoaderFeedback } from './DTRRuleDataLoaderFeedback';

const PREFIX = 'EditDTRRuleDrawer';

const classes = {
  customDrawer: `${PREFIX}-customDrawer`
};

const StyledCustomDrawer = styled(CustomDrawer)(() => ({
  [`& .${classes.customDrawer}`]: {
    width: '450px'
  }
}));

interface Props {
  open: boolean;
  onClose: () => void;
  selectedRow: DTRRule;
}

export const EditDTRRuleDrawer: React.FC<Props> = ({
  open,
  onClose,
  selectedRow
}) => {
  const { t } = useTranslation();


  return (
    (<StyledCustomDrawer
      classes={{
        paper: classes.customDrawer
      }}
      title={t('dtrRules.drawer.title')}
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <DTRRuleDataLoaderFeedback selectedRow={selectedRow} onClose={onClose} />
    </StyledCustomDrawer>)
  );
};
